import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  userInfo: null
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
